import { Image } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function ProductsServicesMtix({ data, locale }) {
  const [trigger, anim] = useScrollAnim()

  return (
    <section className="sc-products-services-mtix" ref={trigger}>
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-img order-2 order-md-1">
            <div className={`mtix-1-wrapper ${anim(4, "slideInUp")}`}>
              <Image
                src="/img/mtix/img_mtix.png"
                className="mtix-1 img-fluid"
                alt="mtix-1"
                fill
              />
            </div>
            <div className={`mtix-2-wrapper ${anim(5, "slideInUp")}`}>
              <Image
                src="/img/mtix/img_mtix-2.png"
                className="mtix-2 img-fluid"
                alt="mtix-2"
                fill
              />
            </div>
          </div>
          <div className="col-md-6 col-text order-1 order-md-2">
            <h1 className={`title ${anim(1)}`}>
              {data && data[`title_${locale}`]}
            </h1>
            <div className={`text ${anim(2, "fadeInUp7")}`}>
              {convertHtmlToReact(data[`description_${locale}`])}
            </div>
            <Link
              href={data?.link_url}
              withArrow
              className={`text-capitalize ${anim(3)}`}
            >
              {data[`link_label_${locale}`]}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsServicesMtix
